<ng-container *ngIf="required">
  <dxc-select [class.required] = "required === true" [class.overlay] = "overlay === true" label="{{label | translate}}" value="{{initialValue}}" [searchable]="true" [options]="suggestions"
(onChange)="onChanges($event)" (onBlur)="onBlur($event)" [disabled] = "isDisable" [optional] = "false" [error]="error"
  >
</dxc-select>
</ng-container>
<ng-container *ngIf="required == false && multiple == false">
  <dxc-select [class.overlay] = "overlay === true"  label="{{label | translate}}" value="{{initialValue}}" [searchable]="true" [options]="suggestionsForOption"
  (onChange)="onChanges($event)" (onBlur)="onBlur($event)" [disabled] = "isDisable" [optional] = "false" [error]="error" [placeholder] = 'placeholder'
  >
  </dxc-select>

</ng-container>
<ng-container *ngIf="multiple">
  <dxc-select [class.required] = "required === true" [class.overlay] = "overlay === true" label="{{label | translate}}" [value]="arrayValue" [options]="suggestions"
(onChange)="onChanges($event)" (onBlur)="onBlur($event)" [disabled] = "isDisable" [error]="error" [multiple]="multiple"
  >
</dxc-select>
</ng-container>
